var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header-layout'),_c('v-main',{staticClass:"brown lighten-5 layout-main"},[_c('v-container',{staticClass:"pt-0 pb-8"},[_c('router-view')],1)],1),_c('footer-layout'),_c('snackbar'),_c('cookies-consent-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }